import React from 'react'
import Navbar from '../components/Home/Navbar/Navbar'
import Footer from '../components/Home/Footer/Footer'

import Appointment from '../components/About/Appointment'
import Landscapingdesign from '../components/Services10/Landscapingdesign'
import Landscapingdesigndetails from '../components/Services10/Landscapingdesigndetails'

const Landscapingdesignpage = () => {
    return (
        <div>
        <Navbar/>
        <main>
        <Landscapingdesign/>
        <Landscapingdesigndetails/>
        
        <Appointment/>
        </main>
        


        <Footer/>

        </div>
    )
}

export default Landscapingdesignpage
